/** Data-channel message size used when the peer does not advertise a maximum. Safe everywhere. */
export const FALLBACK_MESSAGE_BYTES = 16 * 1024;

/** Largest data-channel message we send even when the peer allows more; keeps memory and latency predictable. */
export const MAX_MESSAGE_BYTES = 64 * 1024;

/** The sender reads the file from storage in blocks this large and cuts messages out of them in memory. */
export const READ_BLOCK_BYTES = 4 * 1024 * 1024;

/** The receiver reports progress back to the sender once this many bytes arrived since the last report. */
export const PROGRESS_REPORT_INTERVAL_BYTES = 512 * 1024;

/** Pause sending while more than this many bytes are queued in the data channel. */
export const CHANNEL_HIGH_WATER_MARK_BYTES = 1024 * 1024;

/** Resume sending once the queued amount drops below this value. */
export const CHANNEL_LOW_WATER_MARK_BYTES = 256 * 1024;

/**
 * The receiver folds incoming chunks into a Blob once this many bytes are pending, so the JavaScript
 * heap stays small and the browser can page large files to disk instead of keeping them in memory.
 */
export const RECEIVE_FOLD_BYTES = 8 * 1024 * 1024;

export const ROOM_ID_LENGTH = 10;

/** Alphabet without visually ambiguous characters so room ids can be read aloud. */
export const ROOM_ID_ALPHABET = 'abcdefghjkmnpqrstuvwxyz23456789';

/** Length of the numeric PIN that can be typed instead of opening the link. */
export const PIN_LENGTH = 9;

export const DATA_CHANNEL_LABEL = 'syncport-file';
